import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface BooksReadByGenreResponse {
  books_read_by_genre: {
    fiction: number
    nonfiction: number
  }
}

export type BooksReadByGenreData = BooksReadByGenreResponse['books_read_by_genre']

export async function booksReadByGenre(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<BooksReadByGenreData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('books_read_by_genre', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<BooksReadByGenreResponse>(url, query)
  if (!data) return null

  const { books_read_by_genre } = data
  if (books_read_by_genre.fiction + books_read_by_genre.nonfiction === 0) return null

  return books_read_by_genre
}
